import { compose, gt } from 'ramda';
import color from 'color';

export const luminosity = theme => color(theme).luminosity();
export const isNegative = compose(
  gt(0.25),
  luminosity,
);
export const light = '#fff';
export const dark = '#000';

/**
 * Returns the correct foreground color depending on whether dark mode is enabled.
 *
 * @param {boolean} darkMode whether dark mode is enabled
 * @return {string} hex value of the foreground color
 */
export const getForegroundColor = darkMode => (darkMode ? light : dark);
